import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import TotalMainBankUsageChart from '../charts/MainBankUsage/TotalMainBankUsageChart';
import TotalPrivateChart from '../charts/MainBankUsage/TotalPrivateChart';
import TotalYouthChart from '../charts/MainBankUsage/TotalYouthChart';
import MainBankUsageGranularChart from '../charts/MainBankUsage/MainBankUsageGranularCharts';
import axios from 'axios';
import { provinces, local_market, province_market_map } from '../constants';
import MainBankUsagePPTX from '../powerpoint/MainBankUsagePPTX';

const MainBankUsageMarketShare = ({ heading, total, total_youth, total_private, prestige, private_only, youth, middle_market, mass_market }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState(''); 
  const [localMarkets, setLocalMarkets] = useState([]);
  const [chartsToDisplay, setChartsToDisplay] = useState('total-display');
  const [BankUsageChartDataMain, setBankUsageChartDataMain] = useState([]);
  const [ChartDataPrivate, setChartDataPrivate] = useState([]);
  const [ChartDataYouthAndMiddle, setChartDataYouthAndMiddle] = useState([]);
  const [MainBankUsageDataPrestigeOnly, setMainBankUsageDataPrestigeOnly] = useState([]);
  const [MainBankUsageDataPrivateOnly, setMainBankUsageDataPrivateOnly] = useState([]);
  const [MainBankUsageDataYouthOnly, setMainBankUsageDataYouthOnly] = useState([]);
  const [MainBankUsageDataMassMarketOnly, setMainBankUsageDataMassMarketOnly] = useState([]);
  const [MainBankUsageDataMiddleMarketOnly, setMainBankUsageDataMiddleMarketOnly] = useState([]);

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);
    
    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]); 
    }
    setSelectedLocalMarket(''); 
  };


  const getProvinceValue = () => {
    return selectedProvince ? provinces[selectedProvince] : ''; 
  };

  const getLocalMarketValue = () => {
    return selectedLocalMarket ? local_market[selectedLocalMarket] : ''; 
  };

  useEffect(() => {
    const fetchData = async () => {
      const provinceValue = getProvinceValue();
      const localMarketValue = getLocalMarketValue();
  
      const endpointMapping = [
        { endpoint: 'total', setter: setBankUsageChartDataMain },
        { endpoint: 'total_private', setter: setChartDataPrivate },
        { endpoint: 'youth_main_and_middle', setter: setChartDataYouthAndMiddle },
        { endpoint: 'youth', setter: setMainBankUsageDataYouthOnly },
        { endpoint: 'mass_market', setter: setMainBankUsageDataMiddleMarketOnly },
        { endpoint: 'middle_market', setter: setMainBankUsageDataMassMarketOnly },
        { endpoint: 'prestige', setter: setMainBankUsageDataPrestigeOnly },
        { endpoint: 'private', setter: setMainBankUsageDataPrivateOnly }
      ];
  
      try {
        const promises = endpointMapping.map(({ endpoint }) =>
          axios.get(`https://outlook.plus94research.co.za/api/main-bank-usage/${endpoint}/`, {
            params: {
              province: provinceValue,
              local_market: localMarketValue,
            },
          })
        );
  
        const responses = await Promise.all(promises);
        responses.forEach((response, index) => {
          endpointMapping[index].setter(response.data.chart_data);
        });
  
        console.log("All data fetched successfully");
      } catch (error) {
        console.error('Error fetching data:', error);
        endpointMapping.forEach(({ setter }) => setter([]));
      }
    };
  
    fetchData();
  }, [selectedProvince, selectedLocalMarket]);

  const handleChartDisplayChange = (displayType) => {
    setChartsToDisplay(displayType);
  };
  

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='three-charts-heading-div'>
        <h2 className='heading'>{heading}</h2>
      </div>

 

      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>
        
        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>
      </div>

      <div>
          <MainBankUsagePPTX
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            maindata={BankUsageChartDataMain}
            privatedata={ChartDataPrivate}
            youthdata={ChartDataYouthAndMiddle}
          />
      </div>

     <div className='three-charts-container'>
        <div className='three-charts-left-container'>
          <h2 className='main-bank-total'>{total}</h2>
          <TotalMainBankUsageChart
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            data={BankUsageChartDataMain}
          />
        </div>

        {chartsToDisplay === "total-display" && (
          <div className='three-charts-right-container'>
            <div className='total-youth-mass-and-middle'>
              <h2 
                className='main-bank-total-youth' 
                onClick={() => handleChartDisplayChange('youth-mass-and-middle-only')}
                style={{ cursor: 'pointer' }}
              >
                {total_youth}
              </h2>
              <TotalYouthChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={ChartDataYouthAndMiddle}
              />
            </div>

            <div className='total-private'>
              <h2 
                className='main-bank-total-private'
                onClick={() => handleChartDisplayChange('private-and-prestige')}
                style={{ cursor: 'pointer' }}
              >
                {total_private}
              </h2>
              <TotalPrivateChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={ChartDataPrivate}
              />
            </div>
          </div>
        )}

        {chartsToDisplay === "private-and-prestige" && (
          <div className='private-and-prestige-only'>
            <div>
              <h2 className='prestige-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{prestige}</h2>
              <MainBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={MainBankUsageDataPrestigeOnly}
                id="prestige-only"
              />
            </div>
            <div>
              <h2 className='private-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{private_only}</h2>
              <MainBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={MainBankUsageDataPrivateOnly}
                id="private-only"
              />
            </div>
          </div>
        )}

        {chartsToDisplay === "youth-mass-and-middle-only" && (
          <div className='youth-mass-and-middle-only'>
            <div>
              <h2 className='youth-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{youth}</h2>
              <MainBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={MainBankUsageDataYouthOnly}
                id="youth-only"
              />
            </div>
            <div>
              <h2 className='mass-market-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{mass_market}</h2>
              <MainBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={MainBankUsageDataMassMarketOnly}
                id="mass-market-only"
              />
            </div>
            <div>
              <h2 className='middle-market-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{middle_market}</h2>
              <MainBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={MainBankUsageDataMiddleMarketOnly}
                id="middle-market-only"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainBankUsageMarketShare;

